import React from 'react';
import PropTypes from 'prop-types';
import { GenericDescriptionList } from 'web-ui-components/lib/data/lists';
import { createEWPaymentDetails } from '../utils/helper';
import { ContentProps, EffectiveWarningProps } from '../state/propTypes';

export const PaymentDetails = (props) => (
	<div id="detailsTable">
		<GenericDescriptionList items={createEWPaymentDetails(props)} isFlush />
	</div>
);

PaymentDetails.prototype = {
	effectiveWarning: PropTypes.shape(EffectiveWarningProps),
	content: PropTypes.shape(ContentProps).isRequired,
};

export default PaymentDetails;
